<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            ຂຶ້ນແຜນຕາມຄວາມຕ້ອງການຂອງສັນຍາ
          </h2>
        </div>
      </div>
      <b-tabs v-model="activeTab" v-if="roleid == 2 || roleid == 3">
        <b-tab-item label="ລໍຖ້າຮັບແຜນ">
          <b-field group>
            <b-field label="ຄວາມຕ້ອງການ"></b-field>
            <b-field style="margin: 0  0 0 15px">
              <b>{{ activePlanYear }} </b></b-field
            >
            <b-field style="margin: 0 15px 0 30px">
              ເລືອກປີ
            </b-field>
            <b-field>
              <b-field label="">
                <Multiselect
                  placeholder="ເລືອກ"
                  v-model.trim="selectedYear"
                  label="NAME"
                  track-by="ID"
                  :options="yearList"
                  @input="onYearSelected"
                >
                </Multiselect>
              </b-field>
            </b-field>
            <b-field style="margin-left: 15px;">
              <b-button
                v-if="contractproductwaitlist.length > 0"
                class="btn-group-margin"
                type="is-primary"
                @click="branchRevievePlans()"
                >ຮັບເອົາແຜນທັງໝົດ
              </b-button>
            </b-field>
          </b-field>
          <div>
            ສາຂາ: {{ userBRANCHNAME }}
            <table class="table is-fullwidth is-narrow is-small">
              <thead>
                <tr>
                  <th class="has-text-centered " width="5%">#</th>
                  <th class="has-text-left " width="15%">
                    ເລກທີ
                  </th>
                  <th class="has-text-left " width="15%">
                    ສິນຄ້າ/ ປະເພດ
                  </th>
                  <th class="has-text-left " width="10%">
                    ຈຳນວນ
                  </th>
                  <th class="has-text-left " width="10%">
                    ວັນທີຕ້ອງການ<br />ຜົນຜະລິດ
                  </th>

                  <th class="has-text-left " width="20%">
                    ບ່ອນສົ່ງ
                  </th>
                  <th class="has-text-left " width="40%">
                    ແຂວງທີ່ເລຶອກຜະລິດ
                  </th>
                  <th class="has-text-left " width="10%">
                    ຈັດການ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in contractproductwaitlist"
                  :key="data.B2BID"
                >
                  <td class="has-text-centered">{{ index + 1 }}</td>
                  <td>
                    {{ data.B2BUSERNAME }}<br />
                    {{ data.CONTRACTNO }}/{{ data.SUBCONTRACTNO }}
                  </td>
                  <td>
                    {{ data.PRODUCTNAME }}<br />
                    {{ data.TYPENAME }}
                  </td>
                  <td>{{ data.B2BAMOUNT }} {{ data.UNIT }}</td>
                  <td>
                    {{ dateFormatter(data.REDATE) }}
                  </td>
                  <td>
                    {{ data.PROVINCENAME }} <br />{{ data.DISTRICT }}<br />
                    {{ data.VILLAGE }}
                  </td>
                  <td>
                    {{ data.SELECTEDPROVINCENAME }} 
                    <!-- <Multiselect
                      placeholder="ເລືອກແຂວງ"
                      v-model.trim="data.selectedProvince"
                      label="PROVINCENAME"
                      track-by="PROVINCEID"
                      :options="provinceList"
                    >
                    </Multiselect> -->
                  </td>

                  <td>
                    <b-field>
                      <b-button
                        class="btn-group-margin"
                        type="is-primary"
                        @click="
                          branchRevievePlan(data.B2BID, data.selectedProvince)
                        "
                        >ຮັບເອົາແຜນ
                      </b-button>
                    </b-field>
                    <!-- <b-field>
                      <b-button
                        class="btn-group-margin"
                        type="is-danger"
                        @click="branchSendBackPlan(data.B2BID, data.CONTRACTID)"
                        >ປະຕິເສດແຜນ
                      </b-button>
                    </b-field> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-tab-item>

        <b-tab-item label="ຈັດສັນແຜນ">
          <div class="columns">
            <div class="column">
              <b-tabs v-model="activeFormTab">
                <b-tab-item label="ຈັດສັນແຜນ">
                  <b-field group>
                    <b-field label="ຄວາມຕ້ອງການ"></b-field>
                    <b-field style="margin: 0  0 0 15px">
                      <b>{{ activePlanYear }} </b></b-field
                    >
                    <b-field style="margin: 0 15px 0 30px">
                      ເລືອກປີ
                    </b-field>
                    <b-field>
                      <b-field label="">
                        <Multiselect
                          placeholder="ເລືອກ"
                          v-model.trim="selectedYear"
                          label="NAME"
                          track-by="ID"
                          :options="yearList"
                          @input="onYearWaitSelected"
                        >
                        </Multiselect>
                      </b-field>
                    </b-field>
                  </b-field>
                  <div>
                    ສາຂາ: {{ userBRANCHNAME }}
                    <table class="table is-fullwidth is-narrow is-small">
                      <thead>
                        <tr>
                          <th class="has-text-centered " width="1%">#</th>
                          <th class="has-text-left " width="10%">
                            ເລກທີ
                          </th>
                          <th class="has-text-left " width="10%">
                            ບ່ອນສົ່ງ
                          </th>
                          <th class="has-text-left " width="10%">
                            ປະເພດ <br />
                            ສິນຄ້າ
                          </th>
                          <th class="has-text-centered " width="10%">
                            ຈຳນວນ
                          </th>
                          <!-- <th class="has-text-left " width="5%">
                                  ຍັງເຫຼ່ືອ
                                </th> -->
                          <th class="has-text-centered " width="10%">
                            ເກັບຜົນຜະລິດ
                          </th>
                          <!-- <th class="has-text-left " width="5%">
                                  ປະເພດ
                                </th> -->

                          <th class="has-text-centered " width="10%">
                            ແຂວງຜະລິດ
                          </th>
                          <th class="has-text-centered " width="10%">
                            ຟາມສົນໃຈ/ຖືກເລືອກ
                          </th>
                          <th class="has-text-centered " width="20%">
                            ສະຖານະ
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(data, index) in contractproductlistwait"
                          :key="data.B2BID"
                        >
                          <td class="has-text-centered">{{ index + 1 }}</td>
                          <td>
                            {{ data.B2BUSERNAME }}<br />
                            {{ data.CONTRACTNO }}/{{ data.SUBCONTRACTNO }}
                          </td>
                          <td>
                            {{ data.PROVINCENAME }} <br />{{ data.DISTRICT
                            }}<br />
                            {{ data.VILLAGE }}
                          </td>
                          <td>
                            {{ data.TYPENAME }}<br />
                            {{ data.PRODUCTNAME }}
                          </td>
                          <td class="has-text-centered">
                            {{ data.B2BAMOUNT | formatNumberLocal }}
                            {{ data.UNIT }}
                          </td>
                          <!-- <td>
                                    {{data.REMAINAMOUNT}} <br> {{ data.UNIT }}
                                  </td> -->
                          <td class="has-text-centered">
                            {{ dateFormatter(data.REDATE) }}
                          </td>
                          <td class="has-text-centered">
                            {{ data.PLANOFPROVINCENAME }}
                          </td>

                          <td class="has-text-centered">
                            <b-button
                              class="btn-group-margin"
                              type="is-primary"
                              @click="detailFarmerInterested(data)"
                              >{{ data.COUNTOFFARM }}/{{ data.COUNTOFFARMPLAN }}
                            </b-button>
                          </td>
                          <td class="has-text-centered">
                            <div
                              style=" width: 50%;  margin: 5px auto;"
                              class="statusLabel-organge"
                            >
                              ລໍຖ້າຜະລິດ: {{ data.NUMBEROFPLAN }}
                            </div>
                            <div
                              style="width: 50%; margin: 5px auto;"
                              class="statusLabel-pink"
                            >
                              ກຳລັງຜະລິດ: {{ data.NUMBEROFPRODUCING }}
                            </div>
                            <div
                              style=" width: 50%; margin: 5px auto;"
                              class="statusLabel-passed"
                            >
                              ເກັບກ່ຽວແລ້ວ: {{ data.NUMOFHARVEST }}
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </b-tab-item>
                <b-tab-item label="ຊາວກະສິກອນທີ່ສົນໃຈ">
                  <div>
                    <div class="columns">
                      <div class="column">
                        ລາຍລະອຽດ
                        <table width="80%" class="table borderless">
                          <tr>
                            <td class="has-text-right">
                              B2B:
                            </td>
                            <td>
                              {{ selectedB2BUSER }}
                            </td>
                          </tr>
                          <tr>
                            <td class="has-text-right">
                              ເລກທີສັນຍາ:
                            </td>
                            <td>
                              {{ selectedContractNo }} /
                              {{ selectedSubContractNo }}
                            </td>
                          </tr>
                          <tr>
                            <td class="has-text-right">
                              ສາຂາ/ແຂວງ:
                            </td>
                            <td>
                              {{ userBRANCHNAME }}/ {{ selectedProvinceShow }}
                            </td>
                          </tr>
                          <tr>
                            <td class="has-text-right">
                              ພືດ:
                            </td>
                            <td>{{ selectedType }} / {{ selectedProduct }}</td>
                          </tr>
                          <tr>
                            <td class="has-text-right">
                              ຈຳນວນ:
                            </td>
                            <td>
                              {{ selectedAmount }} / {{ selectedPlanAmount }}
                            </td>
                          </tr>
                          <tr>
                            <td class="has-text-right">
                              ວັນທີຕ້ອງການ:
                            </td>
                            <td>
                              {{ selectedHarvestDate }}
                            </td>
                          </tr>
                          <tr>
                            <td class="has-text-right">
                              ບ່ອນສົ່ງ:
                            </td>
                            <td>
                              {{ selectedDestination }}
                            </td>
                          </tr>
                        </table>
                      </div>
                      <div class="column">
                        ເລືອກຊາວກະສິກອນ
                        <table width="100%" class="table borderless">
                          <thead>
                            <tr>
                              <td>
                                #
                              </td>
                              <td>
                                ຊາວກະສິກອນ
                              </td>
                              <td>
                                ຊື່ຟາມ
                              </td>
                              <td>
                                ທີ່ຕັ້ງຟາມ
                              </td>
                              <td>ຈຳນວນ <br />ສົນໃຈ</td>
                              <td>ຈຳນວນ <br />ທີ່ຈະມອບ</td>
                              <td>
                                ເລືອກ
                              </td>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(data,
                              index) in contractproductlistwaitfamer"
                              :key="data.ID"
                            >
                              <td class="has-text-centered">{{ index + 1 }}</td>

                              <td class="">
                                {{ data.FULLNAME }} <br />
                                {{ data.PHONENO }}
                              </td>
                              <td class="">
                                {{ data.FARMNAME }}
                              </td>
                              <td>
                                {{ data.PROVINCENAME }} <br />{{ data.DISTRICT
                                }}<br />
                                {{ data.VILLAGE }}
                              </td>
                              <td class="has-text-right">
                                {{ data.AMOUNT }}
                              </td>
                              <td>
                                <b-field v-if="data.REMAINAMOUNT > 0">
                                  <b-input v-model.trim="data.REQUESTAMOUNT">
                                  </b-input>
                                </b-field>
                                <b-field v-else-if="data.REMAINAMOUNT == 0">
                                  <span class="statusLabel-organge"
                                    >ເຕັມແລ້ວ</span
                                  >
                                </b-field>
                              </td>

                              <td class="has-text-right">
                                <b-button
                                  v-if="data.REMAINAMOUNT > 0"
                                  class="btn-group-margin"
                                  type="is-primary"
                                  @click="
                                    onSelectFarmer(
                                      data.B2BREQUESTID,
                                      data.REQUESTAMOUNT,
                                      data.REMAINAMOUNT,
                                      data.PRODUCTID,
                                      data.FARMERID,
                                      data.FARMID,
                                      data.RECOMMENTPRODUCEDATE,
                                      data.AREAR
                                    )
                                  "
                                >
                                  ເລືອກ
                                </b-button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </b-tab-item>
                <b-tab-item label="ຊາວກະສິກອນທັງໝົດ">
                  <div>
                    <div class="columns">
                      <div class="column">
                        ລາຍລະອຽດ
                        <table width="80%" class="table borderless">
                          <tr>
                            <td class="has-text-right">
                              B2B:
                            </td>
                            <td>
                              {{ selectedB2BUSER }}
                            </td>
                          </tr>
                          <tr>
                            <td class="has-text-right">
                              ເລກທີສັນຍາ:
                            </td>
                            <td>
                              {{ selectedContractNo }} /
                              {{ selectedSubContractNo }}
                            </td>
                          </tr>
                          <tr>
                            <td class="has-text-right">
                              ສາຂາ/ແຂວງ:
                            </td>
                            <td>
                              {{ userBRANCHNAME }}/ {{ selectedProvinceShow }}
                            </td>
                          </tr>
                          <tr>
                            <td class="has-text-right">
                              ພືດ:
                            </td>
                            <td>{{ selectedType }} / {{ selectedProduct }}</td>
                          </tr>
                          <tr>
                            <td class="has-text-right">
                              ຈຳນວນ:
                            </td>
                            <td>
                              {{ selectedAmount }} / {{ selectedPlanAmount }}
                            </td>
                          </tr>
                          <tr>
                            <td class="has-text-right">
                              ວັນທີຕ້ອງການ:
                            </td>
                            <td>
                              {{ selectedHarvestDate }}
                            </td>
                          </tr>
                          <tr>
                            <td class="has-text-right">
                              ບ່ອນສົ່ງ:
                            </td>
                            <td>
                              {{ selectedDestination }}
                            </td>
                          </tr>
                        </table>
                      </div>
                      <div class="column">
                        ເລືອກຊາວກະສິກອນ
                        <table width="100%" class="table borderless">
                          <thead>
                            <tr>
                              <td>
                                #
                              </td>
                              <td>
                                ຊາວກະສິກອນ
                              </td>
                              <td>
                                ຊື່ຟາມ
                              </td>
                              <td>
                                ທີ່ຕັ້ງຟາມ
                              </td>
                              <td>ຈຳນວນ <br />ທີ່ຈະມອບ</td>
                              <td>
                                ເລືອກ
                              </td>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(data,
                              index) in contractproductlistallfamer"
                              :key="data.ID"
                            >
                              <td class="has-text-centered">{{ index + 1 }}</td>

                              <td class="">
                                {{ data.FULLNAME }} <br />
                                {{ data.PHONENO }}
                              </td>
                              <td class="">
                                {{ data.FARMNAME }}
                              </td>
                              <td>
                                {{ data.PROVINCENAME }} <br />{{ data.DISTRICT
                                }}<br />
                                {{ data.VILLAGE }}
                              </td>
                              <td>
                                <b-field v-if="data.REMAINAMOUNT > 0">
                                  <b-input v-model.trim="data.REQUESTAMOUNT">
                                  </b-input>
                                </b-field>
                                <b-field v-else-if="data.REMAINAMOUNT == 0">
                                  <span class="statusLabel-organge"
                                    >ເຕັມແລ້ວ</span
                                  >
                                </b-field>
                              </td>

                              <td class="has-text-right">
                                <b-button
                                  v-if="data.REMAINAMOUNT > 0"
                                  class="btn-group-margin"
                                  type="is-primary"
                                  @click="
                                    onSelectFarmer(
                                      data.B2BREQUESTID,
                                      data.REQUESTAMOUNT,
                                      data.REMAINAMOUNT,
                                      data.PRODUCTID,
                                      data.FARMERID,
                                      data.FARMID,
                                      data.RECOMMENTPRODUCEDATE,
                                      data.AREAR
                                    )
                                  "
                                >
                                  ເລືອກ
                                </b-button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </b-tab-item>
                <b-tab-item label="ຊາວກະສິກອນທີ່ຖືກເລືອກ ແລະ ການຜະລິດ">
                  <div>
                    <div class="columns">
                      <div class="column">
                        ລາຍລະອຽດ
                        <table width="80%" class="table borderless">
                          <tr>
                            <td class="has-text-right">
                              B2B:
                            </td>
                            <td>
                              {{ selectedB2BUSER }}
                            </td>
                          </tr>
                          <tr>
                            <td class="has-text-right">
                              ເລກທີສັນຍາ:
                            </td>
                            <td>
                              {{ selectedContractNo }} /
                              {{ selectedSubContractNo }}
                            </td>
                          </tr>
                          <tr>
                            <td class="has-text-right">
                              ສາຂາ/ແຂວງ:
                            </td>
                            <td>
                              {{ userBRANCHNAME }}/ {{ selectedProvinceShow }}
                            </td>
                          </tr>
                          <tr>
                            <td class="has-text-right">
                              ພືດ:
                            </td>
                            <td>{{ selectedType }} / {{ selectedProduct }}</td>
                          </tr>
                          <tr>
                            <td class="has-text-right">
                              ຈຳນວນ:
                            </td>
                            <td>
                              {{ selectedAmount }} / {{ selectedPlanAmount }}
                            </td>
                          </tr>
                          <tr>
                            <td class="has-text-right">
                              ວັນທີຕ້ອງການ:
                            </td>
                            <td>
                              {{ selectedHarvestDate }}
                            </td>
                          </tr>
                          <tr>
                            <td class="has-text-right">
                              ບ່ອນສົ່ງ:
                            </td>
                            <td>
                              {{ selectedDestination }}
                            </td>
                          </tr>
                        </table>
                      </div>
                      <div class="column">
                        ຊາວກະສິກອນທີ່ຖືກເລືອກ
                        <table width="100%" class="table borderless">
                          <thead>
                            <tr>
                              <td>
                                #
                              </td>
                              <td>
                                ຊາວກະສິກອນ
                              </td>
                              <td>
                                ຜະລິດ
                              </td>
                              <td>
                                ເກັບກ່ຽວ
                              </td>
                              <!-- <td>
                                ຊື່ຟາມ
                              </td>
                              <td>
                                ທີ່ຕັ້ງຟາມ
                              </td> -->
                              <td>ຈຳນວນ <br />ມອບໃຫ້ຜະລິດ</td>
                              <td class="has-text-centered">
                                ສະຖານະ
                              </td>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(data,
                              index) in contractproductlistplanfamer"
                              :key="data.ID"
                            >
                              <td class="has-text-centered">{{ index + 1 }}</td>

                              <td class="">
                                {{ data.FARMNAME }} <br />
                                {{ data.FULLNAME }} <br />
                                {{ data.PHONENO }} <br />
                                {{ data.PROVINCENAME }} <br />{{ data.DISTRICT
                                }}<br />
                                {{ data.VILLAGE }}
                              </td>
                              <!-- <td class="">
                                {{ data.FARMNAME }}
                              </td>
                              <td>
                                {{ data.PROVINCENAME }} <br />{{ data.DISTRICT
                                }}<br />
                                {{ data.VILLAGE }}
                              </td> -->

                              <td>
                                {{ data.PRODUCEDATE? dateFormatter(data.PRODUCEDATE):'-' }}
                              </td>
                              <td>
                                {{ data.HARVESTDATE ? dateFormatter(data.HARVESTDATE): '-' }}
                              </td>
                              <td>
                                {{ data.AMOUNT }}
                              </td>
                              <td class="has-text-centered">
                                <span
                                  v-if="data.STATUS == 2"
                                  class="statusLabel-organge"
                                  >ລໍຖ້າຜະລິດ</span
                                >
                                <span
                                  v-else-if="data.STATUS == 3"
                                  class="statusLabel-pink"
                                  >ກຳລັງຜະລິດ</span
                                >
                                <span
                                  v-else-if="data.STATUS == 4"
                                  class="statusLabel-passed"
                                  >ເກັບກ່ຽວແລ້ວ</span
                                >
                                <b-button
                                  v-if="data.STATUS == 4"
                                  class="btn-group-margin"
                                  type="is-primary"
                                  @click="transportation(data)"
                                >
                                  ຂໍ້ມູນການຂົນສົ່ງ
                                </b-button>
                                <b-button
                                  v-if="data.STATUS == 4"
                                  class="btn-group-margin"
                                  type="is-danger"
                                  @click="moneyform(data)"
                                >
                                  ຂໍ້ມູນການເງິນ
                                </b-button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </b-tab-item>
                <b-tab-item label="ຂໍ້ມູນການຂົນສົ່ງ">
                  <div>
                    <div class="columns">
                      <div class="column">
                        ລາຍລະອຽດ
                        <table width="80%" class="table borderless">
                          <tr>
                            <td class="has-text-right">
                              ເລກທີຜະລິດ:
                            </td>
                            <td class="shiparea">
                              {{ selectedProductionidShow }}
                            </td>
                          </tr>
                          <tr>
                            <td class="has-text-right">
                              ພືດ:
                            </td>
                            <td class="shiparea">
                              {{ selectedType }} / {{ selectedProduct }}
                            </td>
                          </tr>
                          <tr>
                            <td class="has-text-right">
                              ຈຳນວນ:
                            </td>
                            <td class="shiparea">
                              {{ selectedHarvestAmount }}
                            </td>
                          </tr>
                          <tr>
                            <td class="has-text-right">
                              ວັນທີສົ່ງ:
                            </td>
                            <td class="shiparea">
                              <b-datepicker
                                :date-formatter="dateFormatter"
                                v-model="selecteddate"
                              >
                              </b-datepicker>
                            </td>
                          </tr>
                          <tr>
                            <td class="has-text-right">
                              ລາຍລະອຽດ:
                            </td>
                            <td class="shiparea">
                              <b-input
                                maxlength="500"
                                v-model.trim="shipmentdetail"
                                type="textarea"
                                placeholder="ລາຍລະອຽດການສົ່ງ"
                              ></b-input>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="2" style="text-align: right;">
                              <span v-if="!selectedHarvestAmount"> ສິນຄ້າຍັງບໍ່ທັນເກັບກ່ຽວ</span>
                              <b-button
                                v-else-if="selectedShipAmount <selectedHarvestAmount "
                                class="btn-group-margin"
                                type="is-primary"
                                @click="saveTransportation"
                              >
                                ບັນທຶກການສົ່ງ
                              </b-button> 
                              <span v-else>ສົ່ງຄົບຈຳນວນແລ້ວ</span>
                            </td>
                          </tr>
                        </table>
                      </div>
                      <div class="column">
                        ລາຍການສົ່ງ
                        <table width="100%" class="table borderless">
                          <thead>
                            <tr>
                              <td>
                                #
                              </td>
                              <td>ເລກທີຜະລິດ<br />ເລກທີຂົນສົ່ງ</td>
                              <td>
                                ສິນຄ້າ
                              </td>
                              <td>
                                ຈຳນວນ
                              </td>
                              <td>
                                ວັນທີສົ່ງ
                                <br />
                                ວັນທີເຂົ້າສາງ
                              </td>
                              <td>ລາຍລະອຽດການຂົນສົ່ງ</td>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(data, index) in transportationinfo"
                              :key="data.ID"
                            >
                              <td class="has-text-centered">{{ index + 1 }}</td>

                              <td>
                                {{ data.PRODUCTIONID }}/<br />
                                {{ data.SHIPMENTID }}
                              </td>
                              <td>
                                {{ data.PRODUCTNAME }}
                              </td>
                              <td>
                                {{ data.QUANTITY }}
                              </td>
                              <td>
                                {{ dateFormatter(data.PREDATE) }}<br />
                                {{
                                  data.STOCKDATE
                                    ? dateFormatter(data.STOCKDATE)
                                    : "--"
                                }}
                              </td>

                              <td>
                                {{ data.SHIPMENTDETAIL }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </b-tab-item>

                <b-tab-item label="ຂໍ້ມູນການເງິນ">
                  <div>
                    <div class="columns">
                      <div class="column is-4">
                        ລາຍລະອຽດ
                        <table width="80%" class="table borderless">
                          <tr>
                            <td class="has-text-right">
                              ເລກທີຜະລິດ:
                            </td>
                            <td class="shiparea">
                              {{ selectedProductionidShow }}
                            </td>
                          </tr>
                          <tr>
                            <td class="has-text-right">
                              ຊາວກະສິກອນ:
                            </td>
                            <td class="shiparea">
                              {{ selectedMoneyFarmer }} <br>{{ selectedMoneyFarmerPhoneNo }}
                            </td>
                          </tr>
                          <tr>
                            <td class="has-text-right">
                              ພືດ:
                            </td>
                            <td class="shiparea">
                              {{ selectedType }} / {{ selectedProduct }}
                            </td>
                          </tr>
                          <tr>
                            <td class="has-text-right">
                              ຈຳນວນ:
                            </td>
                            <td class="shiparea">
                              {{ selectedHarvestAmount }}
                            </td>
                          </tr>
                          <tr>
                            <td class="has-text-right">
                              ວັນທີເກັບກ່ຽວ:
                            </td>
                            <td class="shiparea">
                              {{ dateFormatter(selectedMoneyFarmerHarvestDate) }}
                            </td>
                          </tr>
                          <tr>
                            <td class="has-text-right">
                              ຈຳນວນເງິນ:
                            </td>
                            <td class="shiparea">
                              <b-input v-model.trim="total" type="number" > 
                                  </b-input>
                            </td>
                          </tr>
                          <tr>
                            <td class="has-text-right">
                              ລາຍລະອຽດ:
                            </td>
                            <td class="shiparea">
                              <b-input
                                maxlength="500"
                                v-model.trim="paymentdetail"
                                type="textarea"
                                placeholder="ລາຍລະອຽດ"
                              ></b-input>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="2" style="text-align: right;">
                              <b-button
                                class="btn-group-margin"
                                type="is-primary"
                                @click="savePaymentRequest"
                              >
                                ບັນທຶກ ການອອກລາຍຈ່າຍ
                              </b-button> 
                              
                            </td>
                          </tr>
                        </table>
                      </div>
                      <div class="column">
                        ລາຍລະອຽດ ໃບສະເໜີອອກລາຍຈ່າຍ
                        <table width="100%" class="table borderless">
                          <thead>
                            <tr>
                              <td>
                                #
                              </td>
                              <td>ຊາວກະສິກອນ</td>
                              <td>
                                ສິນຄ້າ
                              </td>
                              <td>
                                ຈຳນວນ<br>ສິນຄ້າ
                              </td>
                              <td>
                                ຈຳນວນເງິນ
                              </td>
                              <td>ວັນທີສະເໜີ</td>
                              <td>ລາຍລະອຽດ</td>
                              <td>ສະຖານະ</td>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(data, index) in paymentRequestList"
                              :key="data.ID"
                            >
                              <td class="has-text-centered">{{ index + 1 }}</td>

                              <td>
                                {{ data.FULLNAME }}
                              </td> 
                              <td>
                                {{ data.PRODUCTNAME }}
                              </td>
                              
                              <td>
                                {{ data.QUANTITY | formatNumberLocal}}
                              </td>
                              <td>
                                {{ data.TOTAL | formatNumberLocal}}
                              </td>

                              <td>
                                {{ dateFormatter(data.REQUESTDATE)}}
                              </td>
                              <td>
                                {{ data.DETAIL}}
                              </td>

                              <td>
                                <b-field v-if="data.STATUS==0">
                                  ລໍຖ້າອະນຸມັດ
                                </b-field>
                                <b-field v-else-if="data.STATUS==1">
                                  ອະນຸມັດແລ້ວ
                                </b-field>
                                <b-field v-else-if="data.STATUS==-1">
                                  ຖືກປະຕິເສດ
                                </b-field>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </b-tab-item>
              </b-tabs>
            </div>
          </div>
        </b-tab-item>
        <!-- <b-tab-item label="ຈັດສັນແຜນປະຈຳປີສຳເລັດ">
          <b-field group>
            <b-field label="ຈັດສັນແຜນປະຈຳປີສຳເລັດ"></b-field>
            <b-field style="margin: 0  0 0 15px">
              <b>{{ activePlanYear }} </b></b-field
            >
            <b-field style="margin: 0 15px 0 30px">
              ເລືອກປີ
            </b-field>
            <b-field>
              <b-field label="">
                <Multiselect
                  placeholder="ເລືອກ"
                  v-model.trim="selectedYear"
                  label="NAME"
                  track-by="ID"
                  :options="yearList"
                  @input="onYearSelected"
                >
                </Multiselect>
              </b-field>
            </b-field>
          </b-field>
          <div>
            ສາຂາ: {{ userBRANCHNAME }}
            <table class="table is-fullwidth ">
              <thead>
                <tr>
                  <th class="has-text-centered " width="1%">#</th>
                  <th class="has-text-left " width="20%">
                    ເລກທີ
                  </th>
                  <th class="has-text-left " width="15%">
                    ສິນຄ້າ
                  </th>
                  <th class="has-text-left " width="10%">
                    ຈຳນວນ <br />
                    ຕ້ອງການ
                  </th>
                  <th class="has-text-left " width="10%">
                    ຈຳນວນ <br />
                    ຜະລິດ
                  </th>
     
                  <th class="has-text-left " width="10%">
                    ເກັບຜົນຜະລິດ
                  </th>
        

                  <th class="has-text-left " width="20%">
                    ບ່ອນສົ່ງ
                  </th>

                  <th class="has-text-left " width="30%">
                    ຊາວກະສິກອນ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in contractproductlistassigned"
                  :key="data.PROID"
                >
                  <td class="has-text-centered">{{ index + 1 }}</td>
                  <td>
                    {{ data.B2BUSERNAME }} <br />
                    {{ data.CONTRACTNO }}/{{ data.SUBCONTRACTNO }}
                  </td>
                  <td>
                    {{ data.PRODUCTNAME }}
                  </td>
                  <td>{{ data.B2BAMOUNT }} {{ data.UNIT }}</td>
                  <td>{{ data.PROAMOUNT }} {{ data.UNIT }}</td>
                  <td>
                    {{ dateFormatter(data.REDATE) }}
                  </td>

                  <td>
                    {{ data.PROVINCENAME }} <br />
                    {{ data.DISTRICT }} {{ data.VILLAGE }}
                  </td>
                  <td>
                    {{ data.FARMERNAME }} {{ data.PHONENO1 }}
                    {{ data.FARMNAME }} <br />
                    {{ data.FARMPROVINCENAME }} {{ data.FARMDISTRICT }}
                    {{ data.FARMVILLAGE }}
                  </td>
                  
                </tr>
              </tbody>
            </table>
          </div>
        </b-tab-item> -->
      </b-tabs>
    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import Multiselect from "vue-multiselect";
import moment from "moment";

export default {
  components: { Multiselect },
  props: ["MONTH"],
  data() {
    return {
      roleid: null,
      userName: null,

      activeb2b: [],

      activeTab: 0,
      activeFormTab: 0,
      saveAction: true,
      updateAction: false,
      adddataform: true,
      updatedataform: false,
      contractlist: [],
      contractproductwaitlist: [],
      contractproductlist: [],
      contractproductlistwait: [],
      contractproductlistassigned: [],
      contractproductlistwaitfamer: [],
      contractproductlistassgined: [],
      contractproductlistallfamer: [],
      contractproductlistplanfamer: [],
      yearList: [],
      selectedYear: [],
      activePlanYear: null,
      // farmerList: [{ ID: "1" }, { ID: "2" }],
      farmerList: [],
      selectedFarmer: [],
      farmList: [],
      selectedFarm: [],
      contractProvinceList: [],
      selectedProvince: null,
      provinceList: [],

      selctedInterestID: null,
      selectedType: null,
      selectedProduct: null,
      selectedAmount: null,
      selectedPlanAmount: null,
      selectedHarvestDate: null,
      selectedDestination: null,
      selectedB2BUSER: null,
      selectedContractNo: null,
      selectedSubContractNo: null,
      selectedProvinceShow: null,
      selectedProvinceIDShow: null,
      selectedStockID: null,
      selectedProductionidShow: null,
      selectedHarvestAmount: null,
      selectedShipAmount: null,
      selecteddate: null,
      shipmentdetail: null,
      selectedProductid: null,
      transportationinfo: [],
      selectedshipmentid: null,
      selectedMoneyFarmer: null,
      selectedMoneyFarmerID: null,
      selectedMoneyFarmerPhoneNo: null,
      selectedMoneyFarmerHarvestDate: null,
      total: null,
      paymentdetail: null,
      paymentRequestList: [],
    };
  },
  methods: {
    moneyform(data) {
      console.log("data: " + JSON.stringify(data))
      this.activeFormTab = 5;
      this.selectedProductionidShow = data.ID;
      this.selectedHarvestAmount = data.HARVESTAMOUNT;
      this.selectedProductid = data.PRODUCTID;
      this.selectedMoneyFarmerID = data.FARMERID;
      this.selectedMoneyFarmer = data.FULLNAME;
      this.selectedMoneyFarmerPhoneNo = data.PHONENO;
      this.selectedMoneyFarmerHarvestDate = data.HARVESTDATE;
      this.getPaymentRequest();
      
      // this.getTransportationInfo();
    },

    savePaymentRequest(){
      console.log("total:" + this.total)
      console.log("detail: " + this.paymentdetail) 

      if (this.total === null || this.total == 0) {
        this.$swal("ກະລູນາປ້ອນຈຳນວນເງິນ", "", "error");
      } else {
        this.$swal({
          title: "ຕ້ອງການດຳເນີນການ ແທ້ບໍ່?",
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: "ຕ້ອງການ",
          cancelButtonText: "ບໍ່ຕ້ອງການ",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
        }).then((result) => {
          if (result.value) {
            var params = {
              productionid: this.selectedProductionidShow,
              farmerid: this.selectedMoneyFarmerID,
              productid: this.selectedProductid,
              quantity: this.selectedHarvestAmount,
              total: this.total,
              branchid: this.userBRANCHID,
              detail: this.paymentdetail,
              username: this.username,
            };
            // console.log("params: ", JSON.stringify(params)) 
            RestAPI.savePaymentRequest(params)
              .then(() => {
                this.$swal("ຈັດແຜນໃຫ້ຊາວກະສິກອນ ສຳເລັດ!", "", "success");
                this.getPaymentRequest();
                this.total = null;
                this.paymentdetail = null;
                // this.getDppContractProductList(this.activePlanYear);
              })
              .catch((error) => {
                console.log(error);
                if (error == "Error: Request failed with status code 400") {
                  this.$swal("Check Input Data", "", "error");
                } else {
                  this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                }
              });
          }
        });
      }
    },

    
    getPaymentRequest() {
      RestAPI.getPaymentRequest(this.userBRANCHID, this.selectedProductionidShow) 
        .then((res) => {
          // console.log("list:"+ JSON.stringify(res.data))
          this.paymentRequestList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    newArray(ID) {
      return this.array2.filter((a2) => a2.ID == ID);
    },

    getContractforDpp() {
      RestAPI.getContractforDpp(2) // 2 send to dpp
        .then((res) => {
          // console.log("list:"+ JSON.stringify(res.data))
          this.contractlist = res.data;
          // this.inactivemarkets = res.data.inactivemarkets;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getDppContractProductWait(year) {
      this.isContractProductList = true;
      RestAPI.getDppContractProductWait(year, this.userBRANCHID)
        .then((res) => {
          // console.log("year:", year);
          // console.log("this.userBRANCHID:", this.userBRANCHID);
          // console.log("contractproductlistwait:", JSON.stringify(res.data));
          this.contractproductlistwait = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getDppContractProductAssigned(year) {
      this.isContractProductList = true;
      RestAPI.getDppContractProductAssigned(year, this.userBRANCHID)
        .then((res) => {
          this.contractproductlistassigned = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getDppContractProductWaitFarmer(requestid) {
      // console.log("requestid: " + requestid)
      RestAPI.getDppContractProductWaitFarmer(requestid)
        .then((res) => {
          this.contractproductlistwaitfamer = res.data;
          // console.log("this.contractproductlistwaitfamer : " + JSON.stringify(this.contractproductlistwaitfamer))
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getDppContractProductList(year) {
      this.isContractProductList = true;
      // console.log("this.contractid: " + this.contractid)
      RestAPI.getDppContractProductListBranch(year, this.userBRANCHID)
        .then((res) => {
          this.contractproductwaitlist = res.data.wait;
          this.contractproductlist = res.data.waitselectfamer;
          this.contractproductlistassgined = res.data.approvedlist;
          // console.log("products-: " + JSON.stringify(res.data));
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getYearList() {
      RestAPI.getYearList()
        .then((res) => {
          this.yearList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getActivePlanYear() {
      RestAPI.getActivePlanYear()
        .then((res) => {
          this.activePlanYear = res.data[0].NAME;
          this.getDppContractProductList(this.activePlanYear);
          this.getDppContractProductWait(this.activePlanYear);
          this.getDppContractProductAssigned(this.activePlanYear);
          // console.log("activePlanYear: " + res.data[0].NAME)
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    onYearSelected() {
      this.activePlanYear = this.selectedYear.NAME;
      this.getDppContractProductList(this.activePlanYear);
      this.getDppContractProductAssigned(this.activePlanYear);
    },
    onYearWaitSelected() {
      this.activePlanYear = this.selectedYear.NAME;
      this.getDppContractProductWait(this.activePlanYear);
    },
    getContractProductProvince() {
      RestAPI.getContractProductProvince(2022, 2)
        .then((res) => {
          this.contractProvinceList = res.data;
          // console.log("contractProvinceList: " + JSON.stringify(this.contractProvinceList))
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getBranchofProduction() {
      RestAPI.getBranches()
        .then((res) => {
          this.branchList = res.data.activebranches;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getFarmerList(B2BID) {
      RestAPI.getB2BInterestedFarmerList(B2BID) // ແລ້ວອັບເດດເປັນ branchid ແລະ ໄປຊອກໃນ ຶ branchprovinces
        .then((res) => {
          // this.farmerList = res.data;
          // console.log("B2BID:" + B2BID);
          console.log("farmerlist: " + JSON.stringify(res.data));
          return res.data.FARMID;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    onSelectedFarmer(
      requirementid,
      amount,
      remainamount,
      productid,
      selectedFarmer
    ) {
      // this.getFarm(onSelectedFarmer.FARMERID)
      if (amount === null || amount == 0) {
        this.$swal("ກະລູນາປ້ອນຈຳນວນ", "", "error");
      } else if (amount > remainamount) {
        this.$swal("ຈຳນວນທີ່ປ້ອນ ເກີນຈຳນວນຍັງເຫຼ່ືອ", "", "error");
      } else {
        this.$swal({
          title: "ຕ້ອງການຈັດແຜນໃຫ້ຊາວກະສິກອນ ແທ້ບໍ່?",
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: "ຕ້ອງການ",
          cancelButtonText: "ບໍ່ຕ້ອງການ",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
        }).then((result) => {
          if (result.value) {
            var params = {
              requirementid: requirementid,
              farmerid: selectedFarmer.FARMERID,
              farmid: selectedFarmer.FARMID,
              amount: amount,
              productid: productid,
              username: this.username,
            };
            // console.log("params: ", JSON.stringify(params))
            RestAPI.setContractPlanForFarmer(params)
              .then(() => {
                this.$swal("ຈັດແຜນໃຫ້ຊາວກະສິກອນ ສຳເລັດ!", "", "success");
                this.getDppContractProductList(this.activePlanYear);
              })
              .catch((error) => {
                console.log(error);
                if (error == "Error: Request failed with status code 400") {
                  this.$swal("Check Input Data", "", "error");
                } else {
                  this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                }
              });
          }
        });
      }
    },
    actionToContractPlanForFarmer(requirementid, status) {
      this.$swal({
        title: "ຕ້ອງການດຳເນີນການແທ້ບໍ່ ແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            requirementid: requirementid,
            status: status,
            username: this.username,
          };
          RestAPI.actionToContractPlanForFarmer(params)
            .then(() => {
              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              this.getDppContractProductList(this.activePlanYear);
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },
    // onSelectedProvince(){
    //   this.selectedProvince = farmid: selectedFarm.FARMID
    // },

    onSelectFarmer(
      requirementid,
      amount,
      remainamount,
      productid,
      farmerid,
      farmid,
      recommentproducedate,
      arear
    ) {
      // this.getFarm(onSelectedFarmer.FARMERID)
      if (amount === null || amount == 0) {
        this.$swal("ກະລູນາປ້ອນຈຳນວນ", "", "error");
      } else if (amount > remainamount) {
        this.$swal("ຈຳນວນທີ່ປ້ອນ ເກີນຈຳນວນຍັງເຫຼ່ືອ", "", "error");
      } else {
        this.$swal({
          title: "ຕ້ອງການຈັດແຜນໃຫ້ຊາວກະສິກອນ ແທ້ບໍ່?",
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: "ຕ້ອງການ",
          cancelButtonText: "ບໍ່ຕ້ອງການ",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
        }).then((result) => {
          if (result.value) {
            var params = {
              requirementid: requirementid,
              farmerid: farmerid,
              farmid: farmid,
              amount: amount,
              productid: productid,
              recommentproducedate: recommentproducedate,
              arear: arear,
              username: this.username,
            };
            // console.log("params: ", JSON.stringify(params))
            RestAPI.setContractPlanForFarmer(params)
              .then(() => {
                this.$swal("ຈັດແຜນໃຫ້ຊາວກະສິກອນ ສຳເລັດ!", "", "success");
                this.getDppContractProductWait(this.activePlanYear);
                // this.activeFormTab = 0;
                this.getDppContractProductAssigned(this.activePlanYear);
                this.getDppContractProductWaitFarmer(this.selctedInterestID);
                this.getDppContractProductAllFarmer(
                  this.selectedProvinceIDShow,
                  this.selctedInterestID
                );
                this.getDppContractProductPlanFarmer(this.selctedInterestID);
              })
              .catch((error) => {
                console.log(error);
                if (error == "Error: Request failed with status code 400") {
                  this.$swal("Check Input Data", "", "error");
                } else {
                  this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                }
              });
          }
        });
      }
    },
    getProvinceofBranch() {
      RestAPI.getProvinceofBranch(this.userBRANCHID)
        .then((res) => {
          this.provinceList = res.data;
          // console.log("farm:" + JSON.stringify(this.farmList))
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getFarm(farmerid) {
      // console.log("farmerid: " + farmerid)
      RestAPI.getFarmList(farmerid)
        .then((res) => {
          this.farmList = res.data;
          // console.log("farm:" + JSON.stringify(this.farmList))
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    onSelectedFarm(requirementid, amount, productid, selectedFarm) {
      this.$swal({
        title: "ຕ້ອງການຈັດແຜນໃຫ້ຊາວກະສິກອນ ແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            requirementid: requirementid,
            farmerid: this.selectedFarmer.FARMERID,
            farmid: selectedFarm.FARMID,
            amount: amount,
            productid: productid,
            username: this.username,
          };
          // console.log("params: ", JSON.stringify(params))
          RestAPI.setContractPlanForFarmer(params)
            .then(() => {
              this.$swal("ຈັດແຜນໃຫ້ຊາວກະສິກອນ ສຳເລັດ!", "", "success");
              this.getDppContractProductList(this.activePlanYear);
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },

    branchRevievePlan(B2BID, SELECTEDPROVINCE) {
      console.log("SELECTEDPROVINCE:", JSON.stringify(SELECTEDPROVINCE));
      // if (SELECTEDPROVINCE === undefined) {
      //   this.$swal("ກະລຸນາເລືອກແຂວງ", "", "error");
      // } else {
        var params = {
          requirementid: B2BID,
          // provinceid: SELECTEDPROVINCE.PROVINCEID,
          username: this.username,
        };
        RestAPI.branchRevievePlan(params)
          .then(() => {
            this.$swal("ຮັບເອົາແຜນ ສຳເລັດ!", "", "success");
            this.getActivePlanYear();
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      // }
    },

    branchSendBackPlan(B2BID, CONTRACTID) {
      var params = {
        requirementid: B2BID,
        username: this.username,
      };
      // console.log("params: ", JSON.stringify(params))
      RestAPI.branchSendBackPlan(params)
        .then(() => {
          this.$swal("ປະຕິເສດແຜນ ສຳເລັດ!", "", "success");
          this.getDppContractProductList(this.activePlanYear);
          this.checkAllContractProductSendtoBranch(CONTRACTID);
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },

    checkAllContractProductSendtoBranch(contractno) {
      var params = {
        contractid: contractno,
        username: this.username,
      };
      // console.log("params: ", JSON.stringify(params))
      RestAPI.checkAllContractProductSendtoBranch(params)
        .then((res) => {
          console.log("res:" + JSON.stringify(res.data));
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },

    cancelBranchRevievePlan(B2BID) {
      var params = {
        requirementid: B2BID,
        username: this.username,
      };
      // console.log("params: ", JSON.stringify(params))
      RestAPI.cancelBranchRevievePlan(params)
        .then(() => {
          this.$swal("ຍົກເລີກການຮັບເອົາແຜນ ສຳເລັດ!", "", "success");
          this.getDppContractProductList(this.activePlanYear);
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },

    branchRevievePlans() {
      var params = {
        branchid: this.userBRANCHID,
        year: this.activePlanYear,
        username: this.username,
        contractproduct: this.contractproductwaitlist,
      };
      // console.log("params: ", JSON.stringify(params));
      RestAPI.branchRevievePlans(params)
        .then((res) => {
          // console.log("res:" + JSON.stringify(res.data));
          console.log("res:" + JSON.stringify(res.data));
          if (res.data.result > 0) {
            this.$swal("ຮັບເອົາແຜນ ສຳເລັດ!", "", "success");
            this.getDppContractProductList(this.activePlanYear);
            // this.activeTab = 1;
          } else {
            this.$swal("ກະລຸນາ ເລື່ອກຢ່າງໜ້ອຍ 1 ລາຍການ!", "", "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },

    detailFarmerInterested(data) {
      // console.log(JSON.stringify(data))
      this.activeFormTab = 1;
      this.selctedInterestID = data.B2BID;
      this.selectedType = data.TYPENAME;
      this.selectedProduct = data.PRODUCTNAME;
      this.selectedAmount = data.B2BAMOUNT;
      this.selectedPlanAmount = data.PLANAMOUNT;
      this.selectedHarvestDate = data.REDATE;
      this.selectedDestination =
        data.PROVINCENAME + " " + data.DISTRICT + " " + data.VILLAGE;
      this.selectedB2BUSER = data.B2BUSERNAME;
      this.selectedContractNo = data.CONTRACTNO;
      this.selectedSubContractNo = data.SUBCONTRACTNO;
      this.selectedProvinceShow = data.PLANOFPROVINCENAME;
      this.selectedProvinceIDShow = data.PLANOFPROVINCEID;
      this.selectedStockID = data.SELECTEDSTOCKID;
      this.getDppContractProductWaitFarmer(data.B2BID);
      this.getDppContractProductAllFarmer(
        this.selectedProvinceIDShow,
        data.B2BID
      );
      this.getDppContractProductPlanFarmer(data.B2BID);
    },

    getDppContractProductAllFarmer(provinceid, requestid) {
      // console.log("requestid: " + requestid)
      RestAPI.getDppContractProductAllFarmer(provinceid, requestid)
        .then((res) => {
          console.log("res: " + JSON.stringify(res.data));
          this.contractproductlistallfamer = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getDppContractProductPlanFarmer(requestid) {
      // console.log("requestid: " + requestid)
      RestAPI.getDppContractProductPlanFarmer(requestid)
        .then((res) => {
          console.log("res: " + JSON.stringify(res.data));
          this.contractproductlistplanfamer = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    transportation(data) {
      this.activeFormTab = 4;
      this.selectedProductionidShow = data.ID;
      this.selectedHarvestAmount = data.HARVESTAMOUNT;
      this.selectedProductid = data.PRODUCTID;
      
      this.getTransportationInfo();
      // console.log("data:" + JSON.stringify(data));
      // console.log("SELECTEDSTOCKID: "+ this.selectedStockID) 
    },
    
    getTransportationInfo() {
      RestAPI.getTransportationInfo(this.selectedProductionidShow)
        .then((res) => {
          console.log("res: " + JSON.stringify(res.data));
          
          if(res.data === null){
            this.selectedshipmentid = 0;
          }else{
            this.selectedshipmentid = res.data.SHIPMENTID;
          }
          
          console.log("this.selectedshipmentid: " + this.selectedshipmentid);
          this.transportationinfo = res.data.list;
          this.selectedShipAmount = res.data.shipment.SHIPMENTQUANTTIY;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    

    saveTransportation() {
      var params = {
        productionid: this.selectedProductionidShow,
        productid: this.selectedProductid,
        quantity: this.selectedHarvestAmount,
        shipdate: this.dateFormatterYYYYMMDD(this.selecteddate),
        detail: this.shipmentdetail,
        stockid: this.selectedStockID,
        username: this.username,
      };
      if (this.selecteddate === null) {
        this.$swal("ກະລູນາເລືອກວັນທີ", "", "error");
        return false;
      } else if (this.shipmentdetail === null) {
        this.$swal("ກະລູນາປ້ອນລາຍລະອຽດ", "", "error");
        return false;
      }

      console.log("saveTransportation params: " + JSON.stringify(params));

      RestAPI.saveTransportation(params)
        .then(() => {
          this.$swal("ບັນທຶກການຂົນສົ່ງ ສຳເລັດ!", "", "success");
          this.getTransportationInfo();
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },

    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },

    print() {
      window.print();
    },
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    this.userProvinceID = this.user.BRANCHPROVNICEID;
    this.userBRANCHID = this.user.BRANCHID;
    this.userBRANCHNAME = this.user.BRANCHNAME;
    // this.getB2bUser();
    // this.getCountry();
    this.getActivePlanYear();
    this.getYearList();
    this.getContractforDpp();
    this.getContractProductProvince();
    this.getBranchofProduction();
    this.getFarmerList();
    this.getProvinceofBranch();
    this.selecteddate = new Date();
    this.selectedquotaddate = new Date();
    this.formdate = new Date();
  },
  computed: {
    formdatestr() {
      return new moment(this.formdate).format("YYYY-MM-DD");
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.asterisk {
  color: red;
}
.shiparea {
  padding: 10px 0 10px 0;
}
</style>
